import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { USER_READ, hasPrivilege } from 'utils/privileges';
import config from 'utils/config';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { playlistQueryKeys, useUpdatePlaylistAutoShares } from 'actions/playlists';
import { EditorPageStickySaveDiscardButton } from 'components/EditorPageStickyFooter';
import { AutoShareField, ShareableLinkField, ShareNowField } from 'components/FormFields';
import FormStack from 'components/FormStack';
import { DefaultFormFieldLayout } from 'components/FormField';
import Stack from 'components/Stack';
import TitleCard from 'components/TitleCard';
import UnsavedChangesBlockerModal from 'screens/UnsavedChangesBlockerModal';
import NudgesOverviewCard from 'components/NudgesOverviewCard';
import usePlaylistAutoShareForm from './usePlaylistAutoShareForm';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SinglePlaylistSharePage(_ref) {
  var playlistId = _ref.playlistId,
    autoShareData = _ref.autoShareData,
    shareData = _ref.shareData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaving = _useState2[0],
    setIsSaving = _useState2[1];
  var _usePlaylistAutoShare = usePlaylistAutoShareForm({
      autoShareData: autoShareData
    }),
    fields = _usePlaylistAutoShare.fields,
    wasChanged = _usePlaylistAutoShare.wasChanged,
    hasErrors = _usePlaylistAutoShare.hasErrors,
    reset = _usePlaylistAutoShare.reset;
  var _useUpdatePlaylistAut = useUpdatePlaylistAutoShares({
      playlistId: playlistId
    }),
    updatePlaylistAutoShares = _useUpdatePlaylistAut.updatePlaylistAutoShares;
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var promises, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setIsSaving(true);
            promises = [];
            if (fields.autoShare.wasChanged) {
              promises.push(updatePlaylistAutoShares(fields.autoShare.value));
            }
            _context.prev = 1;
            _context.next = 2;
            return Promise.all(promises);
          case 2:
            setSuccessAlert({
              title: t('alert_playlist_sharing_update_success')
            });
            _context.next = 3;
            return queryClient.invalidateQueries({
              queryKey: playlistQueryKeys.allPlaylists
            });
          case 3:
            reset();
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            setAlert({
              key: 'playlist-share-error',
              title: t('alert_playlist_sharing_update_error'),
              message: _t.message
            });
            _context.next = 5;
            return queryClient.invalidateQueries({
              queryKey: playlistQueryKeys.allPlaylists
            });
          case 5:
            setIsSaving(false);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit,
    children: [/*#__PURE__*/_jsx(UnsavedChangesBlockerModal, {
      hasUnsavedChanges: wasChanged
    }), /*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [shareData && /*#__PURE__*/_jsx(TitleCard, {
        title: t('actions_share_now'),
        children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
          horizontal: true,
          children: /*#__PURE__*/_jsxs(FormStack, {
            spacing: "m",
            children: [/*#__PURE__*/_jsx(ShareNowField, {
              shareData: shareData
            }), /*#__PURE__*/_jsx(ShareableLinkField, {
              contentId: playlistId,
              type: "playlist"
            })]
          })
        })
      }), config.autoSharing && hasPrivilege(USER_READ) && /*#__PURE__*/_jsx(TitleCard, {
        title: t('playlist_access_auto_sharing_title'),
        description: t('hint_autoshare_field'),
        children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
          horizontal: true,
          children: /*#__PURE__*/_jsx(FormStack, {
            children: /*#__PURE__*/_jsx(AutoShareField, {
              playlistId: playlistId,
              audience: autoShareData.audience,
              teams: autoShareData.teams,
              value: fields.autoShare.value,
              wasAutoShareChanged: fields.autoShare.wasChanged,
              onChange: fields.autoShare.set
            })
          })
        })
      }), /*#__PURE__*/_jsx(NudgesOverviewCard, {
        contentId: autoShareData.id,
        type: "playlist"
      })]
    }), /*#__PURE__*/_jsx(EditorPageStickySaveDiscardButton, {
      hasChanges: wasChanged,
      isDisabled: hasErrors,
      isSaving: isSaving,
      onDiscard: function onDiscard() {
        return reset();
      }
    })]
  });
}
export default SinglePlaylistSharePage;